<template>
  <layout>
    <section>
      <div class="columns">
        <div class="column">
          <h1>Projects</h1>
          <hr />
        </div>
      </div>
      <div class="columns is-multiline projects">
        <div
          v-for="project in sortedProjects"
          :key="project.id"
          class="column is-one-third-desktop is-half-tablet"
        >
          <div
            :class="[
              'card',
              'project-card',
              { closed: !isActive(project.end_date) },
            ]"
          >
            <h3 class="name">{{ truncate(project.name) }}</h3>
            <p class="status">
              {{ isActive(project.end_date) ? 'In Progress' : 'Closed' }}
            </p>
            <inertia-link
              :href="route('feedback.project', project.unique_id)"
              v-if="isActive(project.end_date)"
            >
              <b-button expanded type="is-success">View</b-button>
            </inertia-link>
            <b-button v-else disabled> Closed </b-button>
          </div>
        </div>
      </div>
    </section>
  </layout>
</template>

<script>
import Layout from './Layout';

export default {
  components: {
    Layout,
  },
  props: {
    projects: Array,
  },
  methods: {
    isActive(end_date) {
      return Date.now() < Date.parse(end_date);
    },
    truncate(text) {
      let truncateString = text.substring(0, 60);
      if (truncateString.length !== text.length) {
        truncateString += '...';
      }
      return truncateString;
    },
  },
  computed: {
    sortedProjects: function () {
      function compare(a, b) {
        if (a.end_date > b.end_date) return -1;
        if (a.end_date < b.end_date) return 1;
        return 0;
      }
      return this.projects.sort(compare);
    },
  },
};
</script>
